import * as React from 'react';

import styles from './InlineFormatToolbar.modules.scss';

const escapeHtml = (text: string): string =>
  text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

const wrapSelectionWithCode = (): void => {
  const selection = window.getSelection();
  const selectedText = selection?.toString();
  if (!selectedText) {
    return;
  }
  document.execCommand(
    'insertHTML',
    false,
    `<code class="inline-code">${escapeHtml(selectedText)}</code>`
  );
};

const insertLink = (): void => {
  // eslint-disable-next-line no-alert
  const url = window.prompt('Ссылка (https://...)');
  if (!url) {
    return;
  }
  document.execCommand('createLink', false, url);
};

// Toolbar for the raw-HTML `SimpleTextEditor` (contenteditable) fields —
// Bold / inline code / link, matching exactly the subset the shared
// `sanitize()` helper (../utils.ts) allows through. `onMouseDown` +
// `preventDefault` keeps the text selection inside the contenteditable
// field alive so `document.execCommand` applies to it, instead of the
// click first blurring the field (the standard technique for toolbars
// next to a contenteditable region).
const InlineFormatToolbar: React.FC = () => {
  const handleMouseDown = (e: React.MouseEvent, action: () => void): void => {
    e.preventDefault();
    action();
  };

  return (
    <div className={styles.root}>
      <button
        type="button"
        title="Жирный"
        className={styles.button}
        onMouseDown={(e) =>
          handleMouseDown(e, () => document.execCommand('bold'))
        }
      >
        <b>B</b>
      </button>
      <button
        type="button"
        title="Код"
        className={styles.button}
        onMouseDown={(e) => handleMouseDown(e, wrapSelectionWithCode)}
      >
        {'</>'}
      </button>
      <button
        type="button"
        title="Ссылка"
        className={styles.button}
        onMouseDown={(e) => handleMouseDown(e, insertLink)}
      >
        🔗
      </button>
    </div>
  );
};

export default React.memo(InlineFormatToolbar);
